import { NgModule } from '@angular/core';
import {
  NgbAlertModule,
  NgbDatepickerModule,
  NgbModalModule,
  NgbModule,
  NgbTooltip,
  NgbTooltipModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalTarikSaldoComponent } from './components/modal-tarik-saldo/modal-tarik-saldo.component';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { BuatRekeningComponent } from './components/modal-buat-rekening/buat-rek.component';
import { BuatPinComponent } from './components/modal-buat-pin/buat-pin.component';
import { ModalTarikKomisiComponent } from './components/modal-tarik-komisi/modal-tarik-kom.component';
import { ChartAnalyticsComponent } from './components/chart-analytics/chart-analytics.component';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { DashboardComponent } from './dashboard.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ApiUsageComponent } from './components/api-usage/api-usage.component';
import { PaymentServiceComponent } from "./components/payment-service/payment-service.component";
import { QrislyStatComponent } from "./components/qrisly-stat/qrisly-stat.component";
import { DashboardRoutingModule } from './dashboard-routing.module';

@NgModule({
  declarations: [
    ModalTarikSaldoComponent,
    ModalTarikKomisiComponent,
    BuatRekeningComponent,
    BuatPinComponent,
    ChartAnalyticsComponent,
    DashboardComponent,
    ApiUsageComponent,
    PaymentServiceComponent,
    QrislyStatComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbAlertModule,
    NgbDatepickerModule,
    NgbTooltip,
    NgbTooltipModule,
    NgbTypeaheadModule,
    SharedModule,
    NgbModule,
    NgbModalModule,
    AntDModule,
    RouterModule,
    NgxDaterangepickerMd,
    DashboardRoutingModule,
    NgApexchartsModule,
],
})
export class DashboardModule {}
